import { useContext, useEffect } from "react";
import { TestContext } from "../../store/testContext";
import QuestionIntercessor from "../QuestionIntercessor";
import { changeQuestionsListOrder } from "../../store/testActions";
import { DragDropContext, DropResult, Droppable } from "react-beautiful-dnd";

export default function QuestionsList() {
  const {
    dispatch,
    state: { Questions, MinCorrectAnswersCount }
  } = useContext(TestContext);

  function handleOnDragEnd(result: DropResult) {
    if (!result.destination) return;
    const reorderedQuestions = Array.from(Questions);
    const [reorderedItem] = reorderedQuestions.splice(result.source.index, 1);
    reorderedQuestions.splice(result.destination.index, 0, reorderedItem);
    dispatch(changeQuestionsListOrder(reorderedQuestions));
  }

  useEffect(() => {
    localStorage.setItem("questions", JSON.stringify(Questions));
  }, [Questions]);

  useEffect(() => {
    localStorage.setItem("minCorrectAnswersCount", JSON.stringify(MinCorrectAnswersCount));
  }, [MinCorrectAnswersCount]);

  if (!Questions.length) return null;

  return (
    <div>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="questions">
          {provided => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {Questions?.map((question, index) => (
                <QuestionIntercessor index={index} key={question.ID} question={question} />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}
